// Importaciones obligatorias de React y Dependencias del enrutamiento.
import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

//Importar componentes a renderizarse.
import Login from "../pages/Login";
import Inicio from "../pages/Inicio";
import Chats from "../pages/Chats";
import Users from "../pages/Users";
import Remates from "../pages/Remates";
import Configuracion from "../pages/Configuracion";
import LogOut from "../pages/LogOut.js";

//Importar helper de autenticación de permisos de rutas.
import { hasPermission } from "../helpers/storage/hasPermission.js";

//Importar dependencias del React Redux.
import { useSelector } from "react-redux";
import { connectSocket, disconnectSocket } from "../config/socket.js";


const AppRoutes = () => {

  //#Solución para el refresco de la página para setear el valor de la rutaEnSesion.
  //Estado para setear el valor de la ruta actual.
  const [ruta, setRuta] = useState('');
  //Función que no se utiliza para otra cosa que mostrar en consola un mensaje que contiene
  //la ruta a la cuál se está navegando.
  const onChangeRuta = (endPoint) => {
    if (endPoint) {
      setRuta(endPoint);
      // Obtener la ruta en sesión directamente de localStorage en el momento de la comparación
      const rutaEnSesion = localStorage.getItem('rutaEnSesion');
      if (endPoint === rutaEnSesion) {
        console.log(`La ruta ${endPoint} coincide con la ruta en sesión.`);
      }
    }
  };

  //# Sacar el permiso del LocalStorage.
  //Extraer del localStorage la ruta que se encuentra en sesión.
  let rutaEnSesion = localStorage.getItem('rutaEnSesion');
  //Verificar si la ruta en sesión está incluida en el array con los permisos de rutas.
  let permisoLocalStorage = hasPermission(rutaEnSesion)
  //Mostrar en consola el permiso.
  //console.log('permisos desde el localStorage', permisoLocalStorage);


  //# Sacar el permiso del store de React Redux.
  //(Solución al error de no redireccionamiento directo luego del Login)
  //Extraer el array con las rutas permitidas almacenadas en el store.
  const { permissions } = useSelector((state) => state.auth);
  //Guardar el array con la ruta inicial.
  let permisoReducer = permissions;


  //La autenticación "auth" es válida cuándo existe un elemento dentro del array 
  //con la ruta extraída del store de Redux o cuando la ruta en sesión coincida
  //con alguna de las rutas dentro del array Permisos.
  let auth = permisoLocalStorage || (permisoReducer.length > 0);
  //console.log('autenticación: ', auth);


  //********MANEJAR LA CONEXIÓN CON EL SOCKET*********
  const [socketConnected, setSocketConnected] = useState(false); //Estado para actualizar la conexión con el sockect.

  const handleSocketDisconnect = () => { //Función para descontectar el socket.
    setSocketConnected(false);
  };

  useEffect(() => { //se activa con el botón de conectarse para conectarse al socket.
    if (socketConnected) { //Si existe el socket de conexión.
      console.log("ahora voy a volver a conectar el socket");
      let socket = connectSocket(); //Ejecutar la función para conectar el socket.
      socket.on("disconnect", () => { setSocketConnected(false); console.log("se desconecto el socket") });
    } else {
      disconnectSocket();
    }
    return () => {  // Limpia el evento cuando el componente se desmonta
      disconnectSocket();
    };
  }, [socketConnected]);


  return (
    <BrowserRouter basename="/v2">
      <Routes>
        <Route path="/" element={<Login onChangeRuta={onChangeRuta} />} />
        <Route path="*" element={<Navigate to="/" replace />} />

        {/*Ruta Principal "/app"*/}
        <Route path="/app"
          element={
            auth ? <Inicio onChangeRuta={onChangeRuta} ruta='/app' setSocketConnected={setSocketConnected} />
              : <Navigate to="/" />
          } >

          {/*Ruta Anidada "Chats" dentro del sidebar*/}
          <Route path="Chats"
            element={
              auth ? <Chats onChangeRuta={onChangeRuta} ruta='/Chats' socketConnected={socketConnected}
                setSocketConnected={setSocketConnected} />
                : <Navigate to="/" />
            } replace />

          {/*Ruta Anidada "Configuracion" dentro del sidebar*/}
          <Route path="Configuracion"
            element={
              auth ? <Configuracion /* onChangeColorTheme = {onChangeColorTheme}  */ onChangeRuta={onChangeRuta} ruta='/Configuracion' />
                : <Navigate to="/" />
            } replace />

          {/*Ruta Anidada "Usuarios" dentro del sidebar*/}
          <Route path="Usuarios"
            element={
              auth ? <Users onChangeRuta={onChangeRuta} ruta='/Usuarios' />
                : <Navigate to="/" />
            } replace />

          {/*Ruta Anidada "Remates" dentro del sidebar*/}
          <Route path="Remates"
            element={
              auth ? <Remates onChangeRuta={onChangeRuta} ruta='/Remates' />
                : <Navigate to="/" />
            } replace />

          {/*Ruta Anidada "Logout" dentro del sidebar para cerrar sesión*/}
          <Route path="Logout"
            element={
              <LogOut onDisconnectSocket={handleSocketDisconnect} />
            } replace />

        </Route>
      </Routes>
    </BrowserRouter>

  )
};

export default AppRoutes;

